import React, { useEffect } from 'react';
import PageHero from './PageHero';
import AboutSection from './AboutSection';
import AboutInfoTabs from './AboutInfoTabs';
import AboutDonationBanner from './AboutDonationBanner';
import TestimonialsCarousel from './TestimonialsCarousel';
import FounderSection from './FounderSection';
import './AboutPageLayout.css';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <PageHero title="About Us" />
      <AboutSection />
      <AboutInfoTabs />
      <FounderSection />
      <AboutDonationBanner />
      <TestimonialsCarousel />
    </div>
  );
};

export default About;
